
  export default {
    props: {
      checkboxes: { type: Object, default () { return {}; } },
      modelName: { type: String, required: true }
    }
  };
